export default __webpack_public_path__ + "static/media/default_BS.22e80591.jpg";